module.exports = __webpack_public_path__ + "static/media/horo_blue.ad6d0f0a.png";